<template>
  <div class="maskWrap" v-loading="loading">
    <div class="mask">
      <div class="maskCon">
        <span class="close" @click="closeMask">
          <img :src="require('@/assets/imgs/shop/close.png')" alt="">
        </span>
        <div class="maskMain">
          <template v-if="showWhichDialog == 1">
            <div class="dividedAmount">
              <div class="txt">账号金龙元宝余额：{{ icon }}</div>
              <div class="txt">账号银龙元宝余额：{{ bindingIcon }}</div>
              <div class="txt">划分比例：1：100</div>
              <div class="amount">
                <span>游戏大区：</span>
                <el-select v-model="serverId" placeholder="请选择">
                  <el-option v-for="item in getServerList" :key="item.serverId" :label="item.serverName"
                    :value="item.serverId">
                  </el-option>
                </el-select>
              </div>
              <div class="amount">
                <span>划分金额：</span>
                <el-input class="amountInp" v-model="amount"></el-input>
              </div>
              <div class="rechargeWrap">
                <span class="recharge" @click="goRearge">快速充值</span>
                <span class="ok" @click="submit">确定</span>
              </div>
              <div class="tip">温馨提示：本操作不可逆！</div>
            </div>
          </template> <!-- 划分金额-->
          <template v-if="showWhichDialog == 2">
            <div class="copyWriting">
              <div class="tit" v-if="copyWritingTitShow">{{ copyWritingTit }}</div>
              <div class="txt">{{ copyWriting }}</div>
              <div class="rechargeWrap" v-if="copyWritingBtnShow">
                <span class="copyWritingBtn1" @click="funBtn(copyWritingBtn1)">{{ copyWritingBtn1 }}</span>
                <span class="copyWritingBtn2" @click="funBtn(copyWritingBtn2)">{{ copyWritingBtn2 }}</span>
              </div>
            </div>
          </template> <!-- 文案弹窗 -->
          <template v-if="showWhichDialog == 3">
            <div class="inboxWrap">
              <div class="inbox">
                <div class="title">收件箱</div>
                <div class="refresh">
                  <span @click="refresh">刷 新</span>
                  <span @click="collectInfo('all')">一键收取</span>
                </div>
                <div class="collectWrap">
                  <div class="tip">温馨提示：邮件收到后保留30天，30天后默认拒绝！</div>
                </div>
                <div class="giftWrap">
                  <div class="giftCon">
                    <div class="itm" v-for="(item, index) in inBoxList">
                      <div class="itmL">
                        <img :src="require('@/assets/imgs/shop/inboxGift.png')" alt="">
                        <span>{{ item.subject }}</span>
                      </div>
                      <div class="itmC">
                        <img :src="require('@/assets/imgs/shop/inboxTime.png')" alt="">
                        <span>{{ item.expireDays }}</span>
                      </div>
                      <div class="itmR">
                        <span v-if="item.isReject == 1" @click="collectInfo('refuse', item.boxId, index)">拒绝</span>
                        <span @click="collectInfo('single', item.boxId, index)">收取</span>
                      </div>
                    </div>
                  </div>
                  <div class="pageWrap">
                    <el-pagination class="elPagination" background layout="prev, pager, next" prev-text="上一页"
                      next-text="下一页" :current-page="giftNum" :page-size="giftSize" :total="giftTotal"
                      @current-change="giftCurrentChange">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </template> <!-- 收件箱 -->
          <template v-if="showWhichDialog == 4">
            <div class="userUsage">
              <div class="info">
                <div class="txt">道具名称：{{ userPropNam }}</div>
                <div class="txt">持有数量：{{ userHoldCount }}</div>
              </div>
              <div class="amount">
                <span>使用数量：</span>
                <el-input class="amountInp" v-model="usedCount"></el-input>
              </div>
              <div class="rechargeWrap">
                <span class="recharge" @click="closeMask">取消</span>
                <span class="ok" @click="userUsageSublimt">确认</span>
              </div>
              <div class="tip">温馨提示：本操作不可逆！</div>
            </div>
          </template> <!-- 用户使用 -->
          <template v-if="showWhichDialog == 5">
            <div class="userGive">
              <div class="info">
                <div class="txt">道具名称：{{ givePropNam }}</div>
                <div class="txt">持有数量：{{ giveHoldCount }}</div>
              </div>
              <div class="info info1">
                <div class="txt">包装纸当前数量：{{ givePageCount }}</div>
              </div>
              <div class="amount">
                <div class="itm">
                  <span>收件人：</span>
                  <el-input class="amountInp" v-model="receiveMan"></el-input>
                </div>
                <!--<div class="itm">
                  <span>祝福语：</span>
                  <el-input class="amountInp" v-model="blessWords"></el-input>
                </div>-->
              </div>
              <div class="rechargeWrap">
                <span class="recharge" @click="closeMask">取消</span>
                <span class="ok" @click="giveFn">赠送</span>
              </div>
              <div class="tip">赠送后无法取消，每件礼物赠送时消耗一张 包装纸，您的好友可以通过网站邮箱收到您 的礼物！</div>
            </div>
          </template> <!-- 赠送 -->
          <template v-if="showWhichDialog == 6">
            <div class="obtainRecords">
              <img class="title" :src="require('@/assets/imgs/shop/blindBoxRecord.png')" alt="">
              <div class="con">
                <div class="tableHead">
                  <span>时间</span>
                  <span>奖品</span>
                </div>
                <div class="tableBody">
                  <div class="item" v-for="item in recordList">
                    <span class="time">{{ item.date }}</span>
                    <span class="name">{{ item.prizeName }}</span>
                  </div>
                </div>
              </div>
              <el-pagination class="elPagination" background layout="prev, pager, next" prev-text="上一页" next-text="下一页"
                :current-page="pageNum" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </template> <!-- 获取记录 -->
          <template v-if="showWhichDialog == 7">
            <div class="hotSale">
              <div class="title">您确认要<template v-if="buyOrExchange == 'exchange'">兑换</template><template
                  v-else>购买</template>
                “{{ goodTitle }}”吗？</div>
              <div class="propBar">
                <span class="tit">道具数量：</span>
                <img v-if="buyOrExchange != 'exchange'" class="down btn" :class="{ noClick: hotSaleCount <= 1 }"
                  @click="down" :src="require('@/assets/imgs/shop/down.png')" alt="">
                <!-- <span v-if="buyOrExchange == 'exchange'">{{ hotSaleCount }}</span> -->
                <input class="count" type="text" v-model="hotSaleCount" @input="userDefinedCount"
                  @change="cannotEmpty" />
                <img v-if="buyOrExchange != 'exchange'" class="up btn" :class="{ noClick: isNoAdd }" @click="up"
                  :src="require('@/assets/imgs/shop/up.png')" alt="">
                <span v-if="buyOrExchange != 'exchange'" class="max" @click="max"
                  :class="{ noClick: isNoAdd }">最大</span>
              </div>
              <div class="total">
                <span class="tit">总计：</span>
                <template v-if="goodsInfo.currencyName == '金龙元宝'">
                  <Tip :titInd="0" style="width:28px;vertical-align: bottom"></Tip>
                </template>
                <template v-else-if="goodsInfo.currencyName == '银龙元宝'">
                  <Tip :titInd="1" style="width:28px;vertical-align: bottom"></Tip>
                </template>
                <template v-else-if="goodsInfo.currencyName == '积分'">
                  <Tip :titInd="2" style="width:28px;vertical-align: bottom"></Tip>
                </template>
                <template v-else-if="goodsInfo.currencyName == '精品券'">
                  <Tip :titInd="3" style="width:28px;vertical-align: bottom"></Tip>
                </template>
                <span style="margin-left:5px;">{{ Number(hotSaleTotal.toFixed(1)) }}</span>
              </div>
              <div class="userInfoWrap">
                <div v-if="buyOrExchange == 'exchange'" class="userInfo userInfo1">
                  <div class="txt" v-if="buyType == 'integralArea'">拥有积分：{{ points }}</div>
                  <div class="txt" v-else>拥有好运符：{{ clothingCoupon }}</div>
                </div>
                <div v-else class="userInfo">
                  <div class="txt">拥有银龙元宝数量&nbsp;<Tip :titInd="1" style="width:28px;vertical-align: bottom"></Tip>
                    ：{{ bindingIcon }}
                  </div>
                  <div class="txt">拥有金龙元宝数量&nbsp;<Tip :titInd="0" style="width:26px;vertical-align: bottom"></Tip>
                    ：{{ icon }}</div>
                </div>
              </div>
              <div class="pubBtn">
                <span class="btn ok" @click="buyGoods">确定</span>
                <span class="btn cancel" @click="closeMask">取消</span>
              </div>
            </div>
          </template> <!-- 热卖购买-->
          <template v-if="showWhichDialog == 8">
            <div class="blingBox">
              <img class="title" :src="require('@/assets/imgs/shop/blindBoxWish.png')" alt="">
              <div class="goodsCon" :class="{ singleGood: blindBoxParam.length == 1 }">
                <template>
                  <div class="goodsConItem" v-for="(item, index) in blindBoxParam" :key="index">
                    <span class="pic"><img :src="item.prizeImg" alt=""></span>
                    <span class="txt" :style="{ color: item.color }">{{ item.prizeName }}*{{ item.prizeNum }}</span>
                  </div>
                </template>
              </div>
              <div class="draw">
                <img @click="drawGift(1)" :src="require('@/assets/imgs/shop/blindBoxBtn1.png')" alt="">
                <div class="drawCount">
                  <div class="drawCountMain">
                    <img :src="blindBoxBtnCount" alt="">
                    <div class="count">{{ luckyKeyCount }}枚</div>
                  </div>

                  <div class="tip">每抽一次消耗一枚幸运钥匙</div>
                </div>
                <img @click="drawGift(10)" :src="require('@/assets/imgs/shop/blindBoxBtn2.png')" alt="">
              </div>
              <div class="know"><span @click="closeMask">知道啦</span></div>
              <div class="bugBtn" @click="goHome">
                <img :src="require('@/assets/imgs/shop/blindBoxBuy.png')" alt="">
              </div>
            </div>
          </template> <!-- 盲盒抽到物品页面-->
          <template v-if="showWhichDialog == 9"> <!-- 购买成功之后的商品-->
            <div class="blingBox buySuccess">
              <img class="title" :src="require('@/assets/imgs/shop/blindBoxWish.png')" alt="">
              <div class="goodsCon">
                <template>
                  <div class="goodsConItem" v-for="(item, index) in buySuccessData" :key="index">
                    <span class="pic"><img :src="item.itemImg" alt=""></span>
                    <span class="txt">{{ item.itemName }}*{{ item.num }}</span>
                  </div>
                </template>
              </div>
              <div class="know">
                <span class="btn1" @click="closeMask">确定</span>
                <span class="btn2" @click="closeMask">取消</span>
              </div>
            </div>
          </template> <!-- 盲盒抽到物品页面-->

          <template v-if="showWhichDialog == 10">
            <div class="copyWriting">
              <div class="tit"></div>
              <div class="txt">请勿重复发送，本操作不可逆！</div>
              <div class="amount">
                <span>游戏大区：</span>
                <el-select v-model="serverId" placeholder="请选择">
                  <el-option v-for="item in getServerList" :key="item.serverId" :label="item.serverName"
                    :value="item.serverId">
                  </el-option>
                </el-select>
              </div>
              <div class="sendNum">
                <span>发送数量：</span>
                <el-input v-model="sendNum" @input="MaxNum" placeholder="请输入数量"></el-input>
              </div>
              <div class="rechargeWrap">
                <span class="copyWritingBtn1" @click="sendGame">确定</span>
                <span class="copyWritingBtn2" @click="closeMask">取消</span>
              </div>
            </div>
          </template> <!-- 发送到游戏 -->

          <template v-if="showWhichDialog == 11"> <!--抽奖规则说明  -->
            <div class="rule">
              <div style="font-size: 35px;text-align: center;margin-bottom: 25px;">规则说明</div>
              <p>1.每次开启幸运盲盒消耗一把幸运钥匙，可随机获得道具奖励或好运符一枚。</p>
              <p>2.好运符可以在精品商店兑换精美道具奖励。</p>
              <p>3.通过盲盒获取的道具请前往商城—个人仓库查收。</p>
              <p>4.幸运盲盒概率请浏览盲盒页面概率说明，每次开启盲盒均为独立事件。</p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Cookies from "js-cookie";
import eventBus from '@/common/bus.js'
import Tip from "@/components/Tip";
import { outLink, init } from '@/common/outLink.js'
import router from "../../router";
import { checkOutApi, dhCheckOutApi, getServerListApi, getPrizeLogApi } from '@/api/home/index.js'

import { doDivideApi, doSendGameApi, doRecoverApi } from '@/api/personWarehouse/index.js'
import { getMemberInfoApi } from '@/api/login/index.js'
export default {
  name: 'pubMask',
  components: {
    Tip
  },
  props: {
    showWhich: null,
    firstItem: {},       // 个人中心选中的商品
    currentItem: {},     // 当前选中的商品
    goodTitle: '',
    goodsPrice: 0,       // 商品的价格
    maxCount: 1,         // 购买的最大数量
    buyOrExchange: null, // 购买还是兑换
    goodsInfo: {},       // 当前购买商品的全量信息
    decomposeParam: {},  // 分解参数
    inBoxParam: [],      // 收件箱数据
    blindBoxParam: [],   // 盲盒抽取奖品的参数
    luckyKeyCountParam: 0,
  },
  data() {
    return {
      loading: false,            // 弹窗loading
      userInfo: {},              // 用户相关信息
      showWhichDialog: this.showWhich,   // 当前显示哪个弹窗
      buyType: this.$route.query.type,

      /* 盲盒 */
      luckyKeyCount: this.luckyKeyCountParam,          // 抽盲盒的钥匙数量
      recordList: [],                                  // 获取记录
      pageNum: 1,
      pageSize: 10,
      total: 0,
      blindBoxBtnCount: require('@/assets/imgs/shop/blindBoxBtnCount.png'),

      /* 购买成功弹窗 */
      buySuccessData: [],

      /* 收件箱 */
      collect: '',                 // 一键收取
      inBoxList: this.inBoxParam,  // 收件箱数据
      giftNum: 1,
      giftSize: 5,
      giftTotal: 0,

      /* 划分金额 */
      bindingIcon: 0,            // 绑定白金币(赠送)
      icon: 0,                   // 白金币（购买）
      amount: '',                // 用户输入金额

      /* 文案弹窗相关 */
      copyWritingTit: '',        // 文案弹窗title
      copyWritingTitShow: false, //
      copyWriting: '',           // 文案弹窗文案
      copyWritingBtnShow: true,  // 文案弹窗按钮是否显示
      copyWritingBtn1: '',       // 文案弹窗按钮
      copyWritingBtn2: '',       // 文案弹窗按钮
      copyWritingType: '',       // 确定的类型

      /* 用户使用 */
      userPropNam: '',           // 用户使用道具名称
      userHoldCount: '10',       // 用户使用持有数量
      usedCount: '',             // 用户使用数量

      /* 赠送相关 */
      givePropNam: this.firstItem ? this.firstItem.itemName : '',     // 赠送道具名称
      giveHoldCount: this.firstItem ? this.firstItem.itemAllNum : '', // 赠送持有数量
      givePageCount: 0,          // 包装纸数量
      receiveMan: '',            // 收件人
      blessWords: '',            // 祝福语

      /* 购买商品相关 */
      hotSaleCount: 1,           // 购买道具数量
      hotSaleTotal: this.goodsPrice, // 总计
      points: 0,
      clothingCoupon: 0,

      isNoAdd: false,            // 是否可以点击加,

      getServerList: [],    // 大区列表
      serverId: '',      //大区Id
      sendNum: ''
    }
  },
  created() {
    // console.log(this.firstItem,this.currentItem,this.goodsInfo,this.decomposeParam,this.inBoxParam,this.$props);
    
    if (this.maxCount == 1) {
      this.isNoAdd = true
    }
    if (this.showWhichDialog == 3) {
      this.getInBox()
    }
    this.getServer()
  },
  mounted() {
    // console.log(this.showWhich, this.goodTitle, this.goodsPrice, this.buyOrExchange, this.goodsInfo, this.maxCount);

    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.userInfo = userInfo
    this.icon = userInfo.wallteInfos[0].balance             // 金龙元宝
    this.bindingIcon = userInfo.wallteInfos[1].balance       // 银龙元宝
    this.givePageCount = userInfo.wrapper        // 包装纸数量
    this.points = userInfo.vipInfo.points                // 积分
    this.clothingCoupon = userInfo.wallteInfos[3].balance   // 兑换券
  },
  methods: {
    async sendGame() {         // 发送到游戏

      if (this.serverId && this.sendNum) {
        await doSendGameApi({
          itemId: this.currentItem.itemId,     // 道具id
          isbind: this.currentItem.isbind,     // 绑定
          mode: 'sendGame',
          storeId: this.currentItem.storeId,   // 道具在仓库中的id
          level: this.currentItem.level,   // 道具在仓库中的level
          itemType: this.currentItem.itemType,   // 道具在仓库中的id
          userId: Cookies.get('cwsl_userId'),
          serverId: this.serverId,  //发送到游戏选择大区
          itemNum: this.sendNum //发送到游戏 数量
        }).then(res => {
          if (res.data.state == 200) {
            this.$message.success(res.data.message)
            this.getMemberInfo()
            this.serverId = ''
            eventBus.$emit('resetGoodsData')
            this.closeMask()
          } else {
            this.$message.error(res.data.message)
            this.closeMask()
          }
        })

      } else if (!this.serverId) {
        this.$message.error('请选择游戏大区')
      } else if (!this.sendNum) {
        this.$message.error('请输入0-500的整数')
      }

    },
    //发送游戏最大限制
    MaxNum(e) {

      const validValue = e.replace(/[^\d]/g, '');

      // 限制最大值为2000
      if (validValue > 2000) {
        this.sendNum = 2000
      } else {
        this.sendNum = validValue;
      }

    },

    goHome() {       // 进入首页热卖
      this.$router.push({ path: '/shop?type=hot' })
    },
    async getRecordFn() {
      this.loading = true
      await getPrizeLogApi({
        pageNum: this.pageNum,        // 页码数
        pageSize: this.pageSize,      // 每页显示条数
        platForm: 'web',
        userId: Cookies.get('cwsl_userId'),
      }).then(res => {
        this.loading = false
        if (res.data.state == 200) {
          this.recordList = res.data.data.list      // 获取记录
          this.total = res.data.data.counts
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getRecordFn()
    },
    async getMemberInfo() {        // 获取用户信息
      // axios({
      //   method: 'post',
      //   url: '/shop/getMemberInfo',
      //   headers: {
      //     token: Cookies.get('cwsl_token'),
      //   },
      //   data: {
      //     platForm: 'web',
      //     userId: Cookies.get('cwsl_userId'),
      //   },
      // })
      await getMemberInfoApi({
        platForm: 'web',
        userId: Cookies.get('cwsl_userId')
      }).then(res => {
        if (res.data.state == 200) {
          this.isLoginStatus = true
          this.loginInfo = res.data.data
          //sessionStorage.setItem('userInfo',JSON.stringify(res.data.data))
          this.resetSetItem('userInfo', JSON.stringify(res.data.data))
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    /* 盲盒相关 */
    drawGift(count) {                // 抽奖
      this.$emit('drawGiftFn', count)
    },

    /* 收件箱*/
    giftCurrentChange(val) {      // 切换页码
      this.giftNum = val
      this.getInBox()
    },
    getInBox() {
      axios({
        method: 'post',
        url: '/shop/inbox/getUserInboxList',
        headers: {
          token: Cookies.get('cwsl_token'),
        },
        data: {
          platForm: 'web',
          userId: Cookies.get('cwsl_userId'),
          pageNum: this.giftNum,
          pageSize: this.giftSize,
        }
      }).then(res => {
        if (res.data.state == 200) {
          this.giftTotal = res.data.data.counts
          this.inBoxParam = res.data.data.list

        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    refresh() {
      this.$emit('refreshInbox')
    },      // 刷新
    collectInfo(type, id, index) {
      let data = {}
      if (type == 'all') {        // 一键收取
        let boxIds = [];
        this.inBoxList.map(item => {
          boxIds.push(item.boxId)
        })
        let ids = boxIds.join(',')
        data = {
          boxIds: ids,
          flag: 1,
          userId: Cookies.get('cwsl_userId'),
        }
      } else {
        data = {
          boxIds: id,
          flag: (type == 'refuse') ? 2 : 1,
          userId: Cookies.get('cwsl_userId'),
        }
      }
      axios({
        method: 'post',
        url: '/shop/inbox/dealInBox',
        headers: {
          token: Cookies.get('cwsl_token'),
        },
        data: data,
      }).then(res => {
        if (res.data.state == 200) {
          if (index != undefined) {
            this.inBoxList.splice(index, 1)
          } else {
            this.inBoxList = []
            this.closeMask()
          }
          if (this.inBoxList.length == 0) {
            this.$emit('getUserInboxStatus')
          }
          if (type == 'refuse') {
            this.showWhichDialog = 2
            this.copyWriting = '邮件将返还至寄件人邮箱'
            this.copyWritingBtn1 = '确定'
            this.copyWritingBtn2 = '取消'
          } else {
            this.$message.success(res.data.message)
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },  // 收取信息

    /* 划分金额 相关 */
    goRearge() {       // 快速充值
      init()
      window.open(outLink.officeRecharge);
    },
    async submit() {         // 确认划分
      if (parseInt(this.amount) == 0) {
        this.$message.error('请输入划分金额')
      } else if (isNaN(parseInt(this.amount))) {
        this.$message.error('划分金额只能是纯数字')
      } else if ((this.icon + this.bindingIcon) < parseInt(this.amount)) {
        this.$message.error('操作金额大于账号余额！请先充值')
        // this.showWhichDialog = 2
        // this.copyWriting = '操作金额大于账号余额！请先充值'
        // this.copyWritingBtn1 = '取消'
        // this.copyWritingBtn2 = '快速充值'
      } else {
        await doDivideApi({
          coins: this.amount,
          serverId: this.serverId,
          userId: Cookies.get('cwsl_userId'),
        }).then(res => {
          if (res.data.state == 200) {
            this.$message.success(res.data.message)
            this.closeMask()
            eventBus.$emit('resetUserInfo')
            eventBus.$emit('resetGoodsData')
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },

    /* 用户使用 相关*/
    userUsageSublimt() {
      if (parseInt(this.usedCount) == 0) {
        this.$message.error('请输入使用数量')
      } else if (isNaN(parseInt(this.usedCount))) {
        this.$message.error('使用数量只能是纯数字')
      } else if (parseInt(this.userHoldCount) < parseInt(this.usedCount)) {
        this.$message.error('使用数量不能大于持有数量')
      } else {
        this.showWhichDialog = 2
        this.copyWriting = '温馨提示：您的包装纸数量不足， 请先前往商城购买！'
        this.copyWritingBtn1 = '去购买'
        this.copyWritingBtn2 = '取消'
      }
    },

    /* 赠送相关 */
    giveFn() {
      if (this.receiveMan == '') {
        this.$message.error('请输入收件人账号')
      } else if (this.givePageCount < 1) {
        this.showWhichDialog = 2
        this.copyWriting = '温馨提示：您的包装纸数量不足， 请先前往商城购买！'
        this.copyWritingBtn1 = '去购买'
        this.copyWritingBtn2 = '取消'
      } else {
        axios({
          method: 'post',
          url: '/shop/store/doGiftItem',
          headers: {
            token: Cookies.get('cwsl_token'),
          },
          data: {
            itemId: this.currentItem.itemId,     // 道具id
            itemNum: 1,                          // 赠送数量目前只传1
            storeId: this.currentItem.storeId,   // 道具在仓库中的id
            targetAccount: this.receiveMan,      // 收件人游戏账号
            userId: Cookies.get('cwsl_userId'),
          },
        }).then(res => {
          if (res.data.state == 200) {
            this.$message.success(res.data.message)
            this.closeMask()
            this.getMemberInfo()
            eventBus.$emit('resetGoodsData')
          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },

    /* 单个分解：single，一键分解:all*/
    async decompose() {
      await doRecoverApi({
        itemId: this.currentItem.itemId,     // 道具id
        mode: this.copyWritingType,          // 赠送数量目前只传1
        storeId: this.currentItem.storeId,   // 道具在仓库中的id
        userId: Cookies.get('cwsl_userId'),
      }).then(res => {
        if (res.data.state == 200) {
          this.$message.success(res.data.message)
          this.closeMask()
          this.getMemberInfo()
          eventBus.$emit('resetGoodsData')
        } else {
          this.$message.error(res.data.message)
        }
      })
    },

    /* 购买弹窗 */
    down() {    // 减
      if (this.hotSaleCount > 1) {
        this.hotSaleCount--
        this.hotSaleTotal = this.hotSaleCount * this.goodsPrice
        this.isNoAdd = false
      }
    },
    up() {       // 加
      // console.log(this.isNoAdd);
      if (this.isNoAdd) {
        return
      }
      if (this.hotSaleCount + 1 == this.maxCount) {
        this.hotSaleCount = this.maxCount
        this.isNoAdd = true
      } else {
        this.hotSaleCount++
      }
      this.hotSaleTotal = this.hotSaleCount * this.goodsPrice
    },
    max() {        // 最大
      this.hotSaleCount = this.maxCount == 0 ? 1 : this.maxCount;
      this.hotSaleTotal = this.hotSaleCount * this.goodsPrice
      this.isNoAdd = true
    },
    userDefinedCount(count) { //自定义数量
      // 1. 过滤非数字字符，只保留数字
      this.hotSaleCount = this.hotSaleCount.replace(/[^\d]/g, '');

      // 2. 移除开头的0（避免"00123"这种情况）
      if (this.hotSaleCount.length > 1 && this.hotSaleCount[0] === '0') {
        this.hotSaleCount = this.hotSaleCount.replace(/^0+/, '');
      }
      if (this.hotSaleCount > this.maxCount) {
        this.hotSaleCount = this.maxCount
        this.isNoAdd = true
      }
      this.hotSaleTotal = this.hotSaleCount * this.goodsPrice
    },
    cannotEmpty() { // 自定义数量不能为空
      if (this.hotSaleCount == ''||this.hotSaleCount == 0) {
        this.hotSaleCount = 1
        this.hotSaleTotal = this.hotSaleCount * this.goodsPrice

      }
    },
    async buyGoods() {         // 确认购买
      let url = ''
      if (this.buyOrExchange) {
        url = '/shop/order/dhCheckOut'       // 兑换
      } else {
        url = '/shop/order/checkOut'
      }

      let type = this.buyType
      if (type == 'shoppingMall') {
        type = 'luckyCoupon'
      } else if (type == 'integralArea') {
        type = 'points'
      } else {
        type = ''
      }

      let data = {
        buyTypes: type,
        goodsId: this.goodsInfo.goodsId,         // 商品id
        goodsNum: this.hotSaleCount,             // 购买数量
        goodsPrice: this.goodsInfo.goodsPrice,   // 商品价格
        goodsType: this.goodsInfo.goodsType ? this.goodsInfo.goodsType : 0,     // 商品类型
        userId: this.userInfo.userId,            // 用户id
      }
      const res = await (this.buyOrExchange ? dhCheckOutApi({
        ...data
      }) : checkOutApi({
        ...data
      }))
      // .then(res => {
      if (res.data.state == 200) {
        if (this.buyOrExchange) {
          this.$message.success(res.data.message)
          this.closeMask()
        } else {
          if (res.data.data.itemInfo && res.data.data.itemInfo.length > 0) {
            this.showWhichDialog = 9
            this.buySuccessData = res.data.data.itemInfo
          } else {
            if (this.goodsInfo.isPeriod == 1) {
              this.closeMask()
              this.$message.success(res.data.message)
            } else {
              this.showWhichDialog = 2
              this.copyWritingTit = '恭喜获得'
              this.copyWriting = this.goodsInfo.goodsName + ' * ' + this.hotSaleCount
              this.copyWritingTitShow = true
              this.copyWritingBtnShow = false
            }
            eventBus.$emit('resetIndexGoodsList')
          }
        }
        eventBus.$emit('resetUserInfo')
      } else {
        this.$message.error(res.data.message)
      }
      // })
    },
    funBtn(btnTxt) {         // 文案弹窗的功能按钮

      if (btnTxt == '快速充值') {
        window.open(outLink.officeRecharge);
      } else if (btnTxt == '确定' && (this.copyWritingType == 'single' || this.copyWritingType == 'all')) {
        // console.log(btnTxt,this.copyWritingType,'000');

        this.decompose()
      } else if (btnTxt == '去购买') {
        this.$router.push({ path: '/shop' })
      } else {
        this.$emit('closeMask')
      }
    },
    closeMask() {      // 关闭弹窗
      this.showWhichDialog = ''
      this.copyWritingTit = ''        // 清空弹窗文案
      this.copyWriting = ''           // 清空弹窗文案
      this.copyWritingType = ''
      this.copyWritingBtnShow = true
      this.copyWritingTitShow = false
      this.$emit('closeMask')
    },

    async getServer() {
      await getServerListApi({})
        .then(({ data }) => {
          if (data.state == 200) {
            this.getServerList = data.data.list
          }

        })
    }

  },
  watch: {
    showWhich: {
      handler(newVal) {
        if (newVal) {
          this.showWhichDialog = newVal
          if (newVal == 6) {
            this.getRecordFn()
          }
        }
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
    inBoxParam: {
      handler(newVal) {
        if (newVal) {
          this.inBoxList = newVal
        }
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
    decomposeParam: {
      handler(newVal) {
        if (newVal) {
          this.copyWriting = newVal.tip           // 文案弹窗文案
          this.copyWritingBtn1 = newVal.btnOk     // 文案弹窗按钮
          this.copyWritingBtn2 = newVal.btnCancel // 文案弹窗按钮
          this.copyWritingType = newVal.type    // 文案弹窗确定按钮类型
        }
      },
      deep: true, // 深度观察监听 设置为 true
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
}
</script>

<style lang="less">
.dividedAmount {
  .amountInp {
    input {
      width: 210px;
      height: 35px;
      line-height: 35px;
      border: 1px solid #333;
      border-radius: 2px;
      background: none;
      font-size: 22px;
      color: #333;
    }
  }
}

.inboxWrap {
  .collectWrap {
    .el-checkbox {
      .el-checkbox__input {
        margin-top: -5px;

        .el-checkbox__inner {
          width: 22px;
          height: 22px;
          border: 1px solid #FF485E;
        }
      }

      .el-checkbox__input.is-checked {
        .el-checkbox__inner {
          background-color: #FF485E;

          &:after {
            content: "";
            border: 3px solid #FFF;
            border-left: 0;
            border-top: 0;
            height: 13px;
            left: 6px;
            width: 5px;
          }
        }
      }

      .el-checkbox__label {
        font-size: 20px;
        color: #FF485E;
      }
    }
  }
}

.userUsage {
  .amountInp {
    input {
      width: 210px;
      height: 35px;
      line-height: 35px;
      border: 1px solid #333;
      border-radius: 2px;
      background: none;
      font-size: 20px;
    }
  }
}

.userGive {
  .amountInp {
    input {
      width: 210px;
      height: 35px;
      line-height: 35px;
      border: 1px solid #333;
      border-radius: 2px;
      background: none;
      font-size: 20px;
    }
  }
}
</style>
<style scoped lang="less">
.maskWrap {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .4);

  .mask {
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 99;
    padding: 4px;
    transform: translate(-50%, -50%);
    // background: red;
    border-radius: 10px;
    background: linear-gradient(180deg, rgba(84, 114, 246, 1), rgba(154, 173, 255, 1), rgba(255, 248, 249, 1));

    .maskCon {
      position: relative;
      z-index: 1;
      padding: 50px 80px;
      border-radius: 10px;
      background: linear-gradient(180deg, #EBEFFF 0%, #CAD4FF 100%);

      .close {
        position: absolute;
        right: -36px;
        top: -36px;
        z-index: 1;
        width: 100px;
        height: 100px;
        cursor: pointer;

        img {
          width: 100%;
        }
      }
    }
  }
}

.dividedAmount {
  color: #444;

  .txt {
    padding-left: 20px;
    line-height: 45px;
    font-size: 22px;
  }

  .amount {
    margin-bottom: 20px;
    padding-top: 5px;
    display: flex;
    align-items: center;
    padding-left: 20px;

    span {
      min-width: 116px;
      font-size: 22px;
    }
  }

  .rechargeWrap {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    span {
      width: 160px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 22px;
      border-radius: 4px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .recharge {
      border: 2px solid #5472F6;
      background: #fff;
      color: #5472F6;
    }

    .ok {
      color: #fff;
      background: #5472F6;
    }
  }

  .tip {
    font-size: 20px;
    text-align: center;
  }
}

.copyWriting {
  color: #444;
  width: 340px;
  text-align: center;

  .tit {
    font-size: 22px;
    font-weight: 700;
  }

  .txt {
    padding: 40px 20px 20px;
    line-height: 40px;
    font-size: 20px;
  }

  .amount {
    padding-bottom: 20px;
  }

  .sendNum {
    display: flex;
    margin-bottom: 10px;

    span {
      width: 29%;
      line-height: 40px;
      text-align: right;
    }

    >div {
      width: 63%;
    }
  }

  .rechargeWrap {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    span {
      margin-right: 20px;
      width: 160px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 22px;
      border-radius: 4px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .copyWritingBtn1 {
      color: #fff;
      background: #5472F6;
    }

    .copyWritingBtn2 {
      border: 2px solid #5472F6;
      background: #fff;
      color: #5472F6;
    }
  }
}

.inboxWrap {
  .inbox {
    width: 1065px;

    .title {
      text-align: center;
      font-size: 50px;
      font-family: YouSheBiaoTiHei-Regular, YouSheBiaoTiHei;
      font-weight: 400;
      color: #FF485E;
      line-height: 59px;
      letter-spacing: 10px;
      text-shadow: 0px 0px 4px #FF5674;
      -webkit-text-stroke: 1px #FFFFFF;
      text-stroke: 1px #FFFFFF;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 700;
    }

    .refresh {
      margin-bottom: 30px;

      span {
        display: inline-block;
        margin-right: 10px;
        padding: 0 25px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-size: 24px;
        color: #ffffff;
        cursor: pointer;
        background: #FF485E;
      }
    }

    .collectWrap {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .tip {
        font-size: 20px;
        color: #FF485E;
      }
    }

    .giftWrap {
      .giftCon {
        .itm {
          margin-top: 20px;
          display: flex;
          padding: 10px 20px;
          border-radius: 2px 2px 2px 2px;
          border: 2px solid #FF586C;
          justify-content: space-between;
          align-items: center;
          background: rgba(255, 255, 255, 0.5);

          .itmL {
            width: 600px;

            img {
              margin-right: 10px;
              vertical-align: middle;
            }

            span {
              vertical-align: middle;
              color: #FF586C;
              font-size: 24px;
            }
          }

          .itmC {

            img,
            span {
              vertical-align: middle;
            }

            span {
              color: #FF586C;
              font-size: 24px;
            }
          }

          .itmR {
            span {
              display: inline-block;
              width: 100px;
              height: 42px;
              line-height: 42px;
              text-align: center;
              font-size: 24px;
              color: #FF485E;
              border: 2px solid #FF485E;
              cursor: pointer;
              background: #ffffff;

              &:last-child {
                margin-left: 10px;
                color: #ffffff;
                background: #FF485E;
              }
            }
          }
        }
      }

      .pageWrap {
        padding-top: 20px;
        text-align: center;
      }
    }
  }
}

.userUsage {
  color: #444;

  .info {
    display: flex;
    justify-content: space-between;

    .txt {
      padding: 40px 20px 20px;
      line-height: 40px;
      font-size: 20px;
      white-space: nowrap;
    }
  }

  .amount {
    margin-bottom: 20px;
    padding-top: 5px;
    display: flex;
    align-items: center;
    padding-left: 20px;

    span {
      min-width: 104px;
      font-size: 20px;
    }
  }

  .rechargeWrap {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    span {
      margin-right: 20px;
      width: 160px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 22px;
      border-radius: 4px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .recharge {
      border: 2px solid #5472F6;
      background: #fff;
      color: #5472F6;
    }

    .ok {
      color: #fff;
      background: #5472F6;
    }
  }

  .tip {
    font-size: 20px;
    text-align: center;
  }
}

.userGive {
  color: #444;

  .info {
    display: flex;
    justify-content: space-between;

    .txt {
      line-height: 40px;
      font-size: 20px;
    }
  }

  .info1 {
    margin-bottom: 10px;
    justify-content: center;
  }

  .amount {
    margin-bottom: 20px;

    .itm {
      margin-bottom: 10px;
      padding-top: 5px;
      display: flex;
      align-items: center;
      padding-left: 20px;
    }

    span {
      min-width: 94px;
      font-size: 20px;
      text-align: right;
    }
  }

  .rechargeWrap {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;

    span {
      margin-right: 20px;
      width: 160px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 22px;
      border-radius: 4px;
      box-sizing: border-box;
      cursor: pointer;
    }

    .recharge {
      border: 2px solid #5472F6;
      background: #fff;
      color: #5472F6;
    }

    .ok {
      color: #fff;
      background: #5472F6;
    }
  }

  .tip {
    width: 380px;
    font-size: 20px;
    text-align: center;
    line-height: 30px;
  }
}

.hotSale {
  position: relative;
  z-index: 0;
  color: #444;
  width: 364px;

  .title {
    margin-bottom: 30px;
    white-space: nowrap;
    font-size: 22px;
    font-weight: 700;
    text-align: center;
  }

  .propBar {
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      font-size: 20px;
    }

    .btn {
      cursor: pointer;
    }

    .count {
      margin: 0 10px;
      font-weight: 700;
      width: 80px;
      line-height: 25px;
      padding: 0 10px;
      border: none;
      text-align: center;
    }

    .max {
      margin-left: 10px;
      width: 58px;
      height: 30px;
      line-height: 30px;
      border-radius: 4px;
      background: #fff;
      text-align: center;
      cursor: pointer;
    }

    .noClick {
      cursor: default;
      opacity: 0.5;
    }
  }

  .total {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 110px;
    text-align: center;

    span {
      font-size: 20px;
      font-weight: 700;
    }

    .tit {
      font-weight: 700;
    }

    .icon {
      width: 28px;
      margin-right: 8px;
    }

  }

  .userInfoWrap {
    position: absolute;
    left: -80px;
    bottom: 80px;
    padding: 0 20px;
    width: 524px;
    height: 50px;
    line-height: 50px;
    background: rgba(255, 255, 255, .5);
    box-sizing: border-box;

    .userInfo {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .txt {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 10px;
        font-size: 16px;
        white-space: nowrap;
        font-weight: 700;

        img {
          width: 22px;
        }
      }
    }

    .userInfo1 {
      justify-content: center;

    }
  }
}

.blingBox {
  text-align: center;

  .title {
    margin-bottom: 20px;
  }

  .goodsCon {
    margin-bottom: 30px;
    overflow: hidden;
    width: 1000px;

    .goodsConItem {
      float: left;
      margin: 20px 10px 0;
      width: 170px;
      height: 180px;

      .pic {
        display: inline-block;
        margin-bottom: 10px;
        width: 128px;
        height: 112px;
        line-height: 112px;
        border: 4px solid #FF586C;
        text-align: center;

        img {
          max-width: 128px;
          max-height: 112px;
          vertical-align: middle;
        }
      }

      .txt {
        display: block;
        font-size: 20px;
        height: 40px;
        overflow: hidden;
      }
    }
  }

  .singleGood {
    .goodsConItem {
      display: inline-block;
      float: none;
    }
  }

  .draw {
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      transition: all .3s;

      &:hover {
        transform: scale(1.1);
        cursor: pointer;
      }
    }

    .drawCount {
      margin: 0 20px;
      width: 200px;
      text-align: center;
      user-select: none;

      .drawCountMain {
        margin: 0 25px;
        padding-right: 10px;
        width: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid #D22190;
        border-radius: 40px;
        background: #ffffff;
        box-sizing: border-box;

        img {
          margin-top: -3px;
        }
      }

      .count {
        /*padding-left:12px;*/
        font-size: 16px;
        color: #D22190;
        height: 41px;
        line-height: 44px;
        font-weight: 700;
        /*background: url("../../../assets/imgs/shop/blindBoxBtnCount.png") no-repeat top center;*/
      }

      .tip {
        padding-top: 10px;
        font-size: 12px;
        color: #D22190;
      }
    }
  }

  .know {
    margin-bottom: 20px;

    span {
      display: inline-block;
      width: 160px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      color: #FF586C;
      border: 4px solid #FF586C;
      border-radius: 4px;
      font-size: 22px;
      background: #fff;
      cursor: pointer;
    }
  }

  .bugBtn {
    img {
      transition: all .3s;

      &:hover {
        cursor: pointer;
        transform: scale(1.1);
      }
    }
  }
}

.buySuccess {
  .goodsConItem {
    float: inherit !important;
    display: inline-block;

    .pic {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }
  }

  span {
    margin: 0 20px;
  }

  .know {
    .btn1 {
      color: #ffffff;
      background: #ff586c;
    }
  }
}

.obtainRecords {
  text-align: center;
  width: 720px;

  .title {
    margin-bottom: 14px;
  }

  .con {
    margin-bottom: 30px;

    .tableHead {
      display: flex;
      height: 40px;
      justify-content: space-between;
      align-items: center;
      border: 2px solid #5472F6;
      background: rgba(255, 255, 255, .5);
      border-radius: 4px;
      box-sizing: border-box;

      span {
        padding: 0 90px;
        color: #5472F6;
        font-size: 20px;
      }
    }

    .tableBody {
      padding: 10px 30px;

      .item {
        padding: 4px 0;
        line-height: 25px;
        display: flex;
        justify-content: space-between;

        span {
          font-size: 18px;
          color: #5472F6;
        }
      }
    }
  }
}

.rule {
  p {
    height: 30px;
  }
}
</style>
